@if (mode() === 'view') {
    <div class="o-grid">
        <!-- Train input form variant: legacy form with only "Special requests" field visible; to display for pre-August-2023 requests -->
        @if (formGroup().value.travelType !== null && formGroup().value.departureDate === null) {
            <div class="o-grid__row">
                <div class="o-grid__item">
                    <div class="c-info__block">
                        <h5>Special requests</h5>
                        <span>{{ formGroup().controls.specialRequests.value ?? 'Unspecified' }}</span>
                    </div>
                </div>
            </div>
        }
        <!-- Train input form variant: form with all fields visible -->
        @if (
            formGroup().value.travelType !== null &&
            formGroup().value.travelType !== TrainTravelType.NoTravel &&
            formGroup().value.departureDate !== null
        ) {
            <div class="o-grid__row">
                <div class="o-grid__item">
                    <div class="c-info__block">
                        <h5>From station</h5>
                        <span>{{ formGroup().controls.stationOrigin.value }}</span>
                    </div>
                </div>
                <div class="o-grid__item">
                    <div class="c-info__block">
                        <h5>To station</h5>
                        <span>{{ formGroup().controls.stationDestination.value }}</span>
                    </div>
                </div>
            </div>
            <div class="o-grid__row">
                <div class="o-grid__item">
                    <div class="c-info__block">
                        <h5>Departure date</h5>
                        <span>{{ formGroup().controls.departureDate.value?.toDate() | dateFormat | uppercase }}</span>
                    </div>
                </div>
                <div class="o-grid__item">
                    @if (formGroup().value.travelType === TrainTravelType.RoundTrip) {
                        <div class="c-info__block">
                            <h5>Return date</h5>
                            <span>{{ formGroup().controls.returnDate.value?.toDate() | dateFormat | uppercase }}</span>
                        </div>
                    }
                </div>
            </div>
            <div class="o-grid__row">
                <div class="o-grid__item">
                    <div class="c-info__block">
                        <h5>Special requests</h5>
                        <span>{{ formGroup().controls.specialRequests.value ?? 'Unspecified' }}</span>
                    </div>
                </div>
            </div>
        }
    </div>
} @else if (mode() === 'edit' && { travelTypeChange: travelTypeChange$ | async }) {
    <div class="flex flex-col gap-medpace-field">
        @for (error of formGroup().errors | keyvalue; track error.key) {
            <medpace-alert [appearance]="'danger'" [content]="error.value" />
        }
        <div class="flex flex-col">
            <span class="pl-[0.6rem]">
                Choose train ticket type
                <span class="required-asterisk">*</span>
            </span>
            <mds-button-toggle-group
                [buttons]="trainOptionButtons()"
                [multiple]="false"
                [deselectable]="false"
                [formCtrl]="formGroup().controls.travelType"
            />
        </div>
        @if (formGroup().controls.travelType.hasError('required')) {
            <medpace-alert [appearance]="'danger'" [content]="'Please select a train ticket type'" />
        }
        @if (formGroup().value.travelType !== null && formGroup().value.travelType !== TrainTravelType.NoTravel) {
            <div class="grid grid-cols-2 gap-medpace-field">
                <mds-autocomplete
                    id="stationOrigin"
                    [label]="'Station (Origin)'"
                    [appearance]="'outline'"
                    [placeholder]="'Type here...'"
                    [options]="autocompleteOptions().stationOrigin"
                    [formCtrl]="formGroup().controls.stationOrigin"
                />
                <mds-autocomplete
                    id="stationDestination"
                    [label]="'Station (Destination)'"
                    [appearance]="'outline'"
                    [placeholder]="'Type here...'"
                    [formCtrl]="formGroup().controls.stationDestination"
                    [options]="autocompleteOptions().stationDestination"
                />
                <medpace-datepicker
                    id="departureDate"
                    [label]="'Departure Date'"
                    [appearance]="'outline'"
                    [formCtrl]="formGroup().controls.departureDate"
                />
                @if (formGroup().value.travelType === TrainTravelType.RoundTrip) {
                    <medpace-datepicker
                        id="returnDate"
                        [label]="'Return Date'"
                        [appearance]="'outline'"
                        [formCtrl]="formGroup().controls.returnDate"
                    />
                }
            </div>
            <medpace-textarea-autocomplete
                id="specialRequests"
                [autoSize]="true"
                [cdkAutosizeMaxRows]="20"
                [cdkAutosizeMinRows]="5"
                [label]="'Special Requests'"
                [placeholder]="'Special requests - e.g. seat preference'"
                [appearance]="'outline'"
                [formCtrl]="formGroup().controls.specialRequests"
                [options]="autocompleteOptions().specialRequests"
            />
        }
    </div>
}
